<template>
  <div>
    <div>

      <div class="layout-breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#" >
            <span style="color:#fff;">系统管理</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">文件上传</span>
          </Breadcrumb-item>
        </Breadcrumb>
      </div>

      <div class="layout-content">

        <div class="layout-content-main">

          <div class="method-wrapper">
            
             <Button @click="upDateAdmin" type="error" class="mRight" v-if="isbutShow.updateBut">云储存配置</Button>
            <Button @click="addAdmin" type="primary" class="mRight" v-if="isbutShow.addBut">上传新增</Button>
            <Button type="primary" class="mRight" v-if="isbutShow.delBut" @click="delAdmins">删除</Button>
             
          </div>

          <div class="clearfix"></div>

          <div class="table-wrapper">
            <!-- <Table  border :columns="columns4" :data="nodes"></Table> -->
            <Table style="min-width: 700px" border :columns="columns7" :data="pagerData.data" ref="selection" @on-selection-change="getSelection"></Table >
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    <!-- <Page :total="this.total" :current="1" @on-change="changePage"></Page> -->
                     <Page :total="pagerData.page.totalCount" @on-change="onChange"  show-sizer show-elevator show-total  @on-page-size-change="sizeChange"></Page>
                </div>
            </div>
          </div>

        </div>
      </div>


    </div>

  <!-- 新增admin  / 修改-->
    <Modal
      v-model="addModel"
      title="新增" :mask-closable="false">
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>{{modelName}}</span>
        </p>
        <div style="text-align:center">
          <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
              <FormItem label="用户名" prop="name">
                  <Input v-model="formValidate.name" placeholder="请输入用户名"></Input>
              </FormItem>
              <FormItem label="密码" prop="passwd">
                  <Input type="password" v-model="formValidate.passwd"  ref="pwd1"  placeholder="请输入密码"></Input>
              </FormItem>
              <FormItem label="确认密码" prop="passwdCheck">
                  <Input type="password" v-model="formValidate.passwdCheck"  ref="pwd2" placeholder="请输入确认密码" v-on:click="this.CheckPasswd()"></Input>
              </FormItem>
               <FormItem label="所属部门" prop="dePtNode">
                  <!-- <Button type="default" long  @click="getDepartment">所属部门</Button>    -->
                  <!-- {{treeNode}} -->
                  <Button type="default" long style="text-align:left;" @click=" modalDept = true " >{{treeNode}}</Button>
              </FormItem>
              <FormItem label="邮箱" prop="mail">
                  <Input v-model="formValidate.mail" placeholder="请输入邮箱"></Input>
              </FormItem>
               <FormItem label="手机号" prop="phone">
                  <Input v-model="formValidate.phone" placeholder="请输入手机号" v-on:blur="isMobile()" ></Input>
              </FormItem>
              <FormItem label="角色" prop="role">

              </FormItem>
              <FormItem label="状态" prop="status" style="text-align:left;">
                  <RadioGroup v-model="formValidate.status">
                      <Radio label="0" >禁用</Radio>
                      <Radio label="1" >正常</Radio>
                  </RadioGroup>
              </FormItem>
          </Form>
        </div>
        <div slot="footer">
             <Button type="primary" @click="handleSubmit('formValidate')" long   :loading="modal_loading" >确定</Button>
        </div>
    </Modal>
  <!-- 所属部门 -->
  <Modal
        title="所属部门"
        v-model="modalDept"
        :mask-closable="false">
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>所属部门</span>
        </p>
        <div style="text-align:center">
          <!-- <Tree :data="deptLists" show-checkbox ref="tree" @on-toggle-expand="getDeptNodes"></Tree> -->
         <tree-com 
         :deptData="deptLists"
          v-on:getTree = 'getDeptNodes'
          ></tree-com> 
        </div>
        <div slot="footer">
             <Button type="primary" @click="closeDeptModal()" long   >确定</Button>
        </div>
  </Modal>
  
    <Modal
      v-model="updateModel"
       :mask-closable="false">
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>修改</span>
        </p>
        <div style="text-align:center">
          <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
              <FormItem label="用户名" prop="name">
                  <Input ></Input>
              </FormItem>
             <!--  <FormItem label="密码" prop="passwd">
                  <Input type="password" v-model="formValidate.passwd"  ref="pwd1"  placeholder="请输入密码"></Input>
              </FormItem>
              <FormItem label="确认密码" prop="passwdCheck">
                  <Input type="password" v-model="formValidate.passwdCheck"  ref="pwd2" placeholder="请输入确认密码" v-on:click="this.CheckPasswd()"></Input>
              </FormItem> -->
              <FormItem label="Password" prop="passwd">
                <Input type="password" v-model="formValidate.passwd"></Input>
             </FormItem>
            <FormItem label="Confirm" prop="passwdCheck">
                <Input type="password" v-model="formValidate.passwdCheck"></Input>
            </FormItem>
              <FormItem label="邮箱" prop="mail">
                  <Input v-model="formValidate.mail" placeholder="请输入邮箱"></Input>
              </FormItem>
               <FormItem label="手机号" prop="phone">
                  <Input v-model="formValidate.phone" placeholder="请输入手机号" v-on:blur="isMobile()" ></Input>
              </FormItem>
              <FormItem label="角色" prop="role">

              </FormItem>
              <FormItem label="状态" prop="status" style="text-align:left;">
                  <RadioGroup v-model="formValidate.status">
                      <Radio label="0">禁用</Radio>
                      <Radio label="1">正常</Radio>
                  </RadioGroup>
              </FormItem>
             
            
          </Form>
        </div>
        <div slot="footer">
             <Button type="primary" long   :loading="modal_loading" >确定</Button>
        </div>
    </Modal>
  </div>
</template>
<style scoped lang="scss">
  .table-wrapper {
    overflow: scroll;
  }

  .method-wrapper {
    float: left;
    margin-bottom: 10px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }
  .ivu-breadcrumb a{
    color:#fff !important;
  }
  // .ivu-modal-footer{
  //   text-align:center !important;
  // }
  // .ivu-form-item-content{
  //   text-align:left;
  // }
</style>
<script>
  import api from '../../api/apinew'
  import axios from 'axios'
  import Qs from 'qs'
  import treeCom from '../../components/tree'
  // import dateformat from '../../util/dateformat' 

  // import api from '../../api/commonApi'
  export default{
    data(){
       const validatePass = (rule, value, callback) => {
          if (value === '') {
              callback(new Error('请输入密码'));
          } else {
              if (this.formValidate.passwdCheck !== '') {
                  // 对第二个密码框单独验证
                  this.$refs.formValidate.validateField('passwdCheck');
              }
              callback();
          }
      };
      const validatePassCheck = (rule, value, callback) => {
          if (value === '') {
              callback(new Error('请再次输入密码'));
          } else if (value !== this.formValidate.passwd) {
              callback(new Error('两次输入密码不匹配!'));
          } else {
              callback();
          }
      };
      const validatePhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('Age cannot be empty'));
                }
                // 模拟异步验证效果
                setTimeout(() => {
                    if (!Number.isInteger(value)) {
                        callback(new Error('手机号不能为空'));
                    } else {
                        if (!/^1\d{10}$/.test(value)) {
                            callback(new Error('手机号格式不正确'));
                        } else {
                            callback();
                        }
                    }
                }, 1000);
            };
      return {
       isbutShow:{
        addBut: ' ',
        delBut: ' ',
        updateBut: ' ',
        selectBut: ' ',
       },
        modelName:'新增',
        key:'',
        pagerData:{  
           data:[],  
           page:{  
              //分页数  
               // arrPageSize:[10,20,30,40],  
               //分页大小  
               pagesize:10,  
               //总分页数  
               pageCount:1,  
               //当前页面  
               pageCurrent:1,  
               //总数  
               totalCount:0  
           }  

        },
        columns7: [
            {
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {   
                title: 'ID',
                // type: 'index',
                key:'userId',
                width: 60,
                align: 'center'
            },
            {
                title: 'URL地址',
                key: 'username',
                align: 'center'
            },
            {
                title: '创建时间',
                key: 'createTime',
                align: 'center'
            },
        ],
        addModel: false,
        updateModel:false,
        modalDept:false,
        resourcesDept:[],
        treeNode:'所属部门',
        treeNodeId:'',
        deptLists:[
          {
            title: 'parent 1',
            expand: true,
            // selected: true,
            children: [
                {   
                    title: 'parent 1-1',
                    expand: true,
                    children: [
                        {
                            title: 'leaf 1-1-1',
                            // disabled: true
                        },
                        {
                            title: 'leaf 1-1-2'
                        }
                    ]
                },
                {
                    title: 'parent 1-2',
                    expand: true,
                    children: [
                        {
                            title: 'leaf 1-2-1',
                            // checked: true
                        },
                        {
                            title: 'leaf 1-2-1'
                        }
                    ]
                }
            ]
          }
        ],
        selnodeType: '',
        nodeNumber: 1,
        editNodeModel: false,
        selNodetoEdit: {},
        selectionRows:{},
        updateId:'',
        formValidate: {
            name: '',
            passwd:'',
            passwdCheck:'',
            dePtNode:'',
            mail: '',
            phone: '',
            status: '',
        },
        ruleValidate: {
            name: [
                { required: true, message: '用户名不能为空', trigger: 'blur' }
            ],
            passwd:[
                { required: true,validator: validatePass, trigger: 'blur' },
                { type: 'string', min: 6, message: '密码长度不能小于6位', trigger: 'blur'}
            ],
            passwdCheck:[
                { required: true,validator: validatePassCheck, trigger: 'blur' }
            ],
            dePtNode:[
               { required: true, message: '所属部门不能为空',  trigger: 'blur' }
            ],
            mail: [
                { required: true, message: '邮箱不能为空', trigger: 'blur' },
                { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
            ],
            phone:[
               { required: true, message: '手机号不能为空', trigger: 'blur' },
               {validator(rule, value, callback, source, options) {
                  var errors = [];
                  if(!/^1\d{10}$/.test(value)) {
                    // errors.push(
                        callback('手机号格式不正确');
                    }
                    callback(errors);
                }}

            ],
            status: [
                { required: true, message: '状态不能为空', trigger: 'blur' }
            ],
           
        },
        modal_loading: false,
      
      }
    },
    mounted:function(){  
        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        // localStorage.setItem('addpasswd',JSON.stringify(this.formValidate.passwd));
        this.getDepartment()
        
    },
    methods: {
        getLists(pageCurrent,pagesize){
            // var token = sessionStorage.getItem("token");
            api.User.getLists({
                'page':pageCurrent,
                'limit':pagesize,
            }, resp => {
              // console.log(resp)
               // 获取分页展示list
               this.pagerData.data = resp.page.list;
               // 获取分页总条数
               this.pagerData.page.totalCount = resp.page.totalCount;
              // this.getallgateway();
            }, error => {

            })
        // 是否具有增删改查按钮权限
        // var menuLeftList = JSON.parse(localStorage.getItem('menuLeftList'));
        // console.log(menuLeftList[0].list)

        

        // // var list = {
        // //   add:false,
        // //   del:true,
        // //   updata:true,
        // //   select:true
        // // }
        // this.isbutShow.addBut = true;
        // this.isbutShow.delBut = true;
        // this.isbutShow.updateBut = true;
        // this.isbutShow.selectBut = true;
        },
        // 搜索关键词
        showKeyList(){
            // console.log(this.key);
            // var vue = this;
            // var token = sessionStorage.getItem("token")
            if(this.key == ''){
                 this.$Message.error('查询关键词不能为空!');
            }else{
              // console.log('通过关键词获取列表')
               api.User.getLists({
                    'page':this.pagerData.page.pageCurrent,
                    'limit':this.pagerData.page.pagesize,
                    'username':this.key,
                    // 'token':token
                }, resp => {
                  // console.log(resp)
                  // 获取分页展示list
                   this.pagerData.data = resp.page.list;
                   // 获取分页总条数
                   this.pagerData.page.totalCount = resp.page.totalCount;
                   this.key = '';
                }, error => {
                  
                })

            }
        },
        getDepartment:function(){
          console.log(sessionStorage.getItem("token"))
            // api.Department.getLists({

            // }, resp => {
            //   console.log(resp)
            //   // 获取分页展示list
            //    // this.pagerData.data = resp.page.list;
            //    // // 获取分页总条数
            //    // this.pagerData.page.totalCount = resp.page.totalCount;
            //    // this.key = '';
            // }, error => {
              
            // })
            var token = sessionStorage.getItem("token");
            axios.get('http://115.29.214.141:8093/web/sys/dept/list',{params:{
                'token':token
              }},{
              headers: {
                "Content-Type": "application/json",
                'token':token
              }

            }).then(function (response) {
               console.log(response.data);
               
                   
            }).catch(function (error) {
                console.log(error)
            });
           
        },
        getDeptNodes:function(tree){
            // console.log('tree'+tree);
            this.treeNode = tree.name;
            this.treeNodeId = tree.deptId;

        },
        closeDeptModal:function(){
            if(this.treeNode == '所属部门'){
              this.$Message.error('请选择所属部门!');
            }else{
              this.modalDept = false;
              this.formValidate.dePtNode = this.treeNode;
            }
            
        },

        handleSelect(selectedList){
            var ele = selectedList[selectedList.length-1] //当前选中的树节点
            ele.expand = true //设置为展开
        },
        // handleSubmit (name) {
        //     this.$refs[name].validate((valid) => {
        //         if (valid) {
        //             this.$Message.success('Success!');
        //         } else {
        //             this.$Message.error('Fail!');
        //         }
        //     })
        // },
        handleReset (name) {
            this.$refs[name].resetFields();
        },
        handleSubmit (name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                  if(this.formValidate.dePtNode == ''){
                    this.$Message.error('请选择所属部门!');
                  }
                  if(this.modelName == "修改"){
                    api.User.updateAdmin({
                      "username": this.formValidate.name,
                      "password": this.formValidate.passwd,
                      "email": this.formValidate.mail,
                      "mobile": this.formValidate.phone,
                      "deptId": this.treeNodeId,
                      "status": this.formValidate.status,
                      "userId": this.updateId,
                    }, resp => {
                      // console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('修改成功!');
                        this.addModel = false;
                      }

                    }, error => {

                    })
                  }else if(this.modelName == "新增"){
                    api.User.addAdmin({
                      "username": this.formValidate.name,
                      "password": this.formValidate.passwd,
                      "email": this.formValidate.mail,
                      "mobile": this.formValidate.phone,
                      "deptId": this.treeNodeId,
                      "status": this.formValidate.status,
                      // "userId": JSON.parse(localStorage.getItem('user')).userId,
                    }, resp => {
                      console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('新增成功!');
                        this.addModel = false;
                      }

                    }, error => {

                    })
                  }
                  
                    
                } else {
                    this.$Message.error('Fail!');
                }
            })
           

        },
       
        // 删除/批量删除
        delAdmins(){
            // this.selectionRows = this.getSelection();
            console.log(this.selectionRows)
            var userIds = [];
            for(var i=0 ;i < this.selectionRows.length; i++){
                console.log(i);
                userIds.push(this.selectionRows[i].userId);
            }
            console.log(userIds)
            // 执行删除
            this.delAdmin(userIds);
        },
        // 新增 初始化数据
        addAdmin:function(){
            this.modelName = '新增';
            this.formValidate = {
            name: '',
            passwd:'',
            passwdCheck:'',
            dePtNode:'',
            mail: '',
            phone:'',
            status: '',
          }
           this.addModel = true;
        },

        // 修改
        upDateAdmin:function(index){
          this.modelName = '修改';
          if(this.selectionRows.length == undefined || this.selectionRows.length == 0){
              this.$Message.error('请选择一条记录!');
              return;
          }
          if(this.selectionRows.length > 1){
             this.$Message.error('一次只能选择一个进行修改!');
             return;
          }
          // var userId = []
          // console.log(this.selectionRows)
          // userId.push(this.selectionRows[0].userId);
          // console.log(userId)
          this.updateId = this.selectionRows[0].userId
          this.formValidate = {
            name: this.selectionRows[0].username,
            passwd:'',
            passwdCheck:'',
            dePtNode:this.selectionRows[0].deptName,
            mail: this.selectionRows[0].email,
            phone: this.selectionRows[0].mobile,
            status: this.selectionRows[0].status,
          }
          this.addModel = true;
          
        },

        getSelection:function(selection){
          // console.log(222)
            console.log(selection)
            this.selectionRows = selection;
            // return selection;
        },

        formatDate (date) {
          // console.log(date)
          date = new Date()
           // console.log(date)
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            return y + '-' + m + '-' + d;
             // return dateformat(date,'YYYY-MM-dd');
        },

        // 分页 -- 页数改变
        onChange:function(curpage){  
            // alert("当前页面页码是：" + curpage);
            this.pagerData.page.pageCurrent = curpage;
            this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        },
        // 分页 -- pageSize 改变
        sizeChange:function(size){
         // alert("当前页面size是：" + size);
          this.pagerData.page.pagesize = size;
          this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        } ,
        delAdmin:function(userIds){
          var token = sessionStorage.getItem("token");
          axios.post('http://115.29.214.141:8093/web/sys/user/delete',{
                userIds:JSON.stringify(userIds),
                
              },{
              headers: {
                "Content-Type": "application/json",
                "token":token
              }

            }).then(function (response) {
               
               this.resourcesDept = response.data;
               for(var i=0;i<this.resourcesDept.length;i++){
                  
                this.deptLists[i].title = this.resourcesDept[i].name;
                this.deptLists[i].expand = true;
                if(this.resourcesDept[i].open == true){
                   this.deptLists[i].children = this.resourcesDept[i].list;
                  for(var j=0;j<this.resourcesDept[i].length;j++){
                    this.deptLists[i][j].title = this.resourcesDept[i][j].name;
                    this.deptLists[i][j].expand = true;
                  }

                }


              }
               console.log(this.deptLists)
              // var aa =   [{
              //     title: this.resourcesDept[i].name,
              //     expand: true,
              //     selected: true,
              //     children: [
              //         {
              //             title: 'this.resourcesDept[i].list[j].name',
              //             expand: true,
              //             children: [
              //                 {
              //                     title: 'leaf 1-1-1',
              //                 },
              //                 {
              //                     title: 'leaf 1-1-2'
              //                 }
              //             ]
              //         },
              //         {
              //             title: 'parent 1-2',
              //             expand: true,
              //             children: [
              //                 {
              //                     title: 'leaf 1-2-1',
              //                     checked: true
              //                 },
              //                 {
              //                     title: 'leaf 1-2-1'
              //                 }
              //             ]
              //         }
              //     ]
              //   }];
              // this.pagerData.data.splice(index, 1);

               // 获取分页展示list
               // vue.pagerData.data = response.data.page.list;
               // // 获取分页总条数
               // vue.pagerData.page.totalCount = response.data.page.totalCount;
               // vue.key = '';
               // setTimeout(() => {
              //     this.modal_loading = false;
              //     this.addModel = false;
              //     this.$Message.success('新增成功!');
              // }, 2000);
                   
            }).catch(function (error) {
                console.log(error)
            });
        }

    },

      components: {treeCom}
    }
</script>



// WEBPACK FOOTER //
// fileUpload.vue?e6d27f9e